import { create } from 'zustand'

interface ModalState {
   isSelectUserOrganizationModalOpen: boolean
   openSelectUserOrganizationModal: () => void
   closeSelectUserOrganizationModal: () => void
}

export const useSelectUserOrganizationModalStore = create<ModalState>(
   (set) => ({
      isSelectUserOrganizationModalOpen: false,
      openSelectUserOrganizationModal: () =>
         set({ isSelectUserOrganizationModalOpen: true }),
      closeSelectUserOrganizationModal: () =>
         set({ isSelectUserOrganizationModalOpen: false }),
   })
)
